import type React from 'react';
import emailIcon from '@/assets/icons/email.png';
import nameIcon from '@/assets/icons/name.png';
import phoneIcon from '@/assets/icons/phone.png';
import { ActionButton, LoadingSpinner } from '@/components/atoms/primitives';
import { AuthFormLayout, FormField } from '@/components/molecules';
import { SignUpStage, type StageProps } from '../types';

export const PersonalDetailsStage: React.FC<StageProps> = ({ form, setForm, setStage, error, setError, loading }) => {
  const handleContinue = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const validatedEmail = emailRegex.test(form.email);

    const phoneRegex = /^\d{10}$/;
    const validatePhone = phoneRegex.test(form.phoneNumber);

    if (validatePhone && validatedEmail) {
      setStage(SignUpStage.PASSWORD);
      setError(false);
    } else {
      if (!validatePhone && !validatedEmail) {
        setError('Invalid email & phone number');
      } else {
        if (!validatePhone) {
          setError('Invalid phone number');
        } else if (!validatedEmail) {
          setError('Invalid email');
        }
      }
    }
  };

  if (loading) {
    return (
      <div className="flex w-1/2 p-16 flex-col justify-center items-center bg-[#0a0e1a] text-white">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  return (
    <AuthFormLayout title="Sign Up" error={error}>
      <FormField
        label="Full Name"
        value={form.name}
        onChange={(value) => setForm({ ...form, name: value })}
        placeholder="John Doe"
        icon={nameIcon}
        iconAlt="Name icon"
        fullWidth
      />

      <FormField
        label="Email Address"
        type="email"
        value={form.email}
        onChange={(value) => setForm({ ...form, email: value })}
        placeholder="johndoe@email.com"
        icon={emailIcon}
        iconAlt="Email icon"
        fullWidth
      />

      <FormField
        label="Phone Number"
        type="tel"
        value={form.phoneNumber}
        onChange={(value) => setForm({ ...form, phoneNumber: value })}
        placeholder="9546738542"
        icon={phoneIcon}
        iconAlt="Phone icon"
        fullWidth
      />

      <ActionButton
        type="button"
        onClick={handleContinue}
        className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transition duration-200 mt-4"
      >
        Continue
      </ActionButton>
    </AuthFormLayout>
  );
};
